// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookOfMind__parent___O9mgY {
    height: 390px;
    width: 100%;
    overflow: hidden;
}

.BookOfMind__child___uE0T5 {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding-right: 17px; /* Increase/decrease this value for cross-browser compatibility */
    box-sizing: content-box; /* So the width will be 100% + 17px */
}

.BookOfMind__bookOfMindLoadingSpinner___L8HAq {
    margin-top: 20px;
    text-align: center;
    animation: BookOfMind__bookOfMindLoadingSpinnerFadeIn___K1WT4 1s ease-out both;
}

@keyframes BookOfMind__bookOfMindLoadingSpinnerFadeIn___K1WT4 {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.BookOfMind__quoteParent___U80j9 {
    font-size: 8px;
    opacity: 0.6;
    font-style: italic;
    margin-left: 10px;
    font-size: 10px;
}

.BookOfMind__quoteParentReveal___qcVXk {
    opacity: 0;
    animation: BookOfMind__bookOfMindQuoteParentReveal___QYQcQ 420ms ease-out both;
}

@keyframes BookOfMind__bookOfMindQuoteParentReveal___QYQcQ {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.BookOfMind__quoteParentContext___s_IIr {
    color: rgba(217, 191, 114, 0.72);
    font-size: 10px;
    font-style: italic;
    opacity: 0.72;
    animation: BookOfMind__bookOfMindParentContextFadeIn___T6yT0 300ms ease-out both;
}

@keyframes BookOfMind__bookOfMindParentContextFadeIn___T6yT0 {
    from {
        opacity: 0;
    }

    to {
        opacity: 0.72;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"parent": `BookOfMind__parent___O9mgY`,
	"child": `BookOfMind__child___uE0T5`,
	"bookOfMindLoadingSpinner": `BookOfMind__bookOfMindLoadingSpinner___L8HAq`,
	"bookOfMindLoadingSpinnerFadeIn": `BookOfMind__bookOfMindLoadingSpinnerFadeIn___K1WT4`,
	"quoteParent": `BookOfMind__quoteParent___U80j9`,
	"quoteParentReveal": `BookOfMind__quoteParentReveal___qcVXk`,
	"bookOfMindQuoteParentReveal": `BookOfMind__bookOfMindQuoteParentReveal___QYQcQ`,
	"quoteParentContext": `BookOfMind__quoteParentContext___s_IIr`,
	"bookOfMindParentContextFadeIn": `BookOfMind__bookOfMindParentContextFadeIn___T6yT0`
};
module.exports = ___CSS_LOADER_EXPORT___;
